module.exports = __webpack_public_path__ + "img/icon2.a9942ed3.svg";